// extracted by mini-css-extract-plugin
export default {"tupacGrid":"vm-z","tupacHeader":"wm-z","tupacHeader2":"xm-z","tupacMenu":"ym-z","tupacMenu2":"zm-z","tupacMain":"Am-z","tupacMain2":"Bm-z"};